/**
 * Created by yihong on 5/11/18.
 */
import {openLink} from './link'
import to_casher from './casher'
import {isObject} from '../typeof'
export function process_error_action(action_obj, default_msg) {
  if (!isObject(action_obj) ||  !action_obj.type) {
    default_msg && window.$toast(default_msg);
    return;
  }
  switch (action_obj.type) {
    case 'toast':
      window.$toast(action_obj.msg);
      break;
    case 'alert_dialog':
      window.$act_alert_dialog.show({
        title: `<div style="text-align: center;font-size:.32rem;color:#666;margin-bottom:.2rem">${action_obj.msg}</div>`,
        button: action_obj.button
      }).then(res => {
        if (action_obj.action === 'share') {
          window.$share_dialog.show()
        } else if (action_obj.action === 'jumpurl') {
          openLink(action_obj.url);
        } else if (action_obj.action === 'cashier') {
          to_casher()
        } else {
          //close modal do notion
        }
      }).catch(res => {
      });
      break;
    default:
      default_msg && window.$toast(default_msg);
  }


}



// WEBPACK FOOTER //
// ./src/tools/mgtv/error_action.js